import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5b97a70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "el-carousel el-carousel--horizontal fd-recruitment-carousel"
}
const _hoisted_2 = { class: "el-carousel__container" }
const _hoisted_3 = {
  class: "el-carousel__item is-active is-animating",
  style: {"background-color":"#FFFFFF"}
}
const _hoisted_4 = { class: "fd-recruitment-wrap" }
const _hoisted_5 = { class: "fd-recruitment-company" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("工作机会")
const _hoisted_7 = { class: "fd-recruitment-company-item" }
const _hoisted_8 = { class: "fd-recruitment-company" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("人才库")
const _hoisted_10 = { class: "fd-recruitment-company-item" }
const _hoisted_11 = { class: "fd-recruitment-company" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("猎头推荐")
const _hoisted_13 = { class: "fd-recruitment-company-item" }

import store from "@/store/index";
import { ref, reactive } from "vue";
import Bottom from './components/bottom.vue'
import router from "@/router/index";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const findJobs = require('@/assets/fd/jobs/jobs_example3.jpg')
const findPeople = require('@/assets/fd/jobs/jobs_example2.jpg')
const headhunter = require('@/assets/fd/jobs/jobs_example4.jpg')


const bindData = reactive({
  isShowDefaultImage: true,
  defaultImage: '',
  images: [],
});
const advertisingImageEvent = () => {
  store
    .dispatch("frontIndexModule/listAdvertisingImage", { type: 7 })
    .then(
      (data) => {
        console.log(data.result);
        bindData.images = data.result;
        if (data.result.length > 0) {
          bindData.defaultImage = data.result[0];
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

advertisingImageEvent();

const toMemberReg = () => {
  router.push("/frontDesk/member");
};

setTimeout(() => { bindData.isShowDefaultImage = false }, 3000);

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(bindData).isShowDefaultImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_image, {
                class: "fd-recruitment-carousel-banner",
                src: _unref(bindData).defaultImage
              }, null, 8, ["src"])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_el_carousel, {
          key: 1,
          class: "fd-recruitment-carousel"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).images, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: index,
                style: {"background-color":"#FFFFFF"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    class: "fd-recruitment-carousel-banner",
                    src: item
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_tabs, { class: "demo-tabs" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, { label: "找工作" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_container, { class: "fd-recruitment-divider" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_divider, { "content-position": "center" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_container, { class: "fd-recruitment-company-list" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_el_image, { src: _unref(findJobs) }, null, 8, ["src"])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, { label: "找人才" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_container, { class: "fd-recruitment-divider" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_divider, { "content-position": "center" }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_container, { class: "fd-recruitment-company-list" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_image, { src: _unref(findPeople) }, null, 8, ["src"])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, { label: "猎头服务" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_container, { class: "fd-recruitment-divider" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_divider, { "content-position": "center" }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_container, { class: "fd-recruitment-company-list" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_image, { src: _unref(headhunter) }, null, 8, ["src"])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(Bottom)
  ]))
}
}

})